import React, { memo, useMemo } from "react";
import ButtonComponent from "../../../components/ButtonMC";

/**
 * @fileoverview Componente Molecule para mostrar la integración de un contacto con una plataforma externa y acciones asociadas.
 * @component CustomerIntegrationItemMC
 * @category Component - Molecule
 * @since 1.0.0
 * @version 1.1.0
 *
 * @description
 * Componente optimizado para mostrar el logo de integración, descripción y botones de acción relacionados con la integración de un contacto.
 *
 * **Características:**
 * - Muestra logo de la plataforma integrada
 * - Presenta descripción personalizada
 * - Permite mostrar uno o varios botones de acción (sincronizar, eliminar, etc.)
 * - Diseño responsive y alineado con TailwindCSS
 * - Optimizado con React.memo y useMemo
 *
 * **Atomic Design:**
 * - Nivel: Molecule
 * - Composición: Usa ButtonComponent (atom)
 */
const CustomerIntegrationItemMC = memo(({
  description,
  iconSrc,
  buttons = []
}) => {
  // Memoizar los botones para evitar renders innecesarios
  const renderedButtons = useMemo(() => (
    buttons.length > 0 && (
      <div className="tw-flex tw-flex-col tw-items-center">
        {buttons.map((button, index) => (
          <div key={index} className="tw-mb-2 tw-w-full tw-flex tw-justify-center">
            <ButtonComponent
              variant={button.variant}
              outlined={button.outlined}
              text={button.text}
              onClick={button.onClick}
              disabled={button.disabled}
              icon={button.icon}
              className={`tw-text-default tw-font-medium !tw-px-4 ${button.className || ''}`}
            />
          </div>
        ))}
      </div>
    )
  ), [buttons]);

  return (
    <div className="tw-wrapper tw-mb-2">
      <div className="tw-border tw-rounded-xl tw-px-4 tw-py-3 tw-border-gray-200">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
          <img src={iconSrc} alt="Integration Logo" className="tw-w-8 tw-h-8" />
          <span>
            {description}
          </span>
        </div>
        {renderedButtons}
      </div>
    </div>
  );
});

CustomerIntegrationItemMC.displayName = 'CustomerIntegrationItemMC';

export default CustomerIntegrationItemMC;
